import React from "react";

import { Avatar, ListItem, Text } from "/component/base";
import { layout } from "/styles";
import { formatISODateTimeString } from "/util/date";
import { parseInitials } from "/util/formatText";

interface Props {
  children?: React.ReactElement;
  name?: {
    firstName: string | null;
    lastName: string | null;
  };
  dob: Date;
  imageUrl?: string;
  onClick: () => void;
}

const CaregiverCard = ({
  name = { firstName: "", lastName: "" },
  dob,
  imageUrl,
  onClick,
}: Props) => {
  const fullName = `${name.firstName} ${name.lastName}`;

  return (
    <ListItem.Button newDesign onClick={onClick}>
      <Avatar initials={parseInitials(name)} alt={fullName} src={imageUrl} />

      <div css={[layout.flexVerticalAlignStart, layout.marginHorizontal("standard")]}>
        <Text align="left" variant="body1Bold">
          {fullName}
        </Text>
        <Text align="left" color="textSecondary" variant="body1">
          {`Date of birth: ${formatISODateTimeString(dob.toISOString(), "LLL dd, yyyy")}`}
        </Text>
      </div>
    </ListItem.Button>
  );
};

export default CaregiverCard;
